import './public-path'
import Vue from 'vue'
import App from './App.vue'
import 'babel-polyfill'
import Es6Promise from 'es6-promise'
import '@/permission' // permission control
import './sentry'
import 'echarts'
import { GDKye } from 'api/config'
import VueAMap from 'vue-amap'
import 'normalize.css/normalize.css'
import '@/filters/filters'
import '@/icons' // icon
import componentsList from './components'
import '@/utils/showErrMessage'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import * as filters from './filters/filters.js'
import router from './router'
import store from './store'
import { setting } from './setting'
import './imgMerge'
import putIfAbsent from '@/utils/putIfAbsent'
import YUI from '@yxqn/ui'
import '@yxqn/ui/theme-chalk/index.less'
import '@/styles/shixiang.less'
import '@/styles/common.less'
import './directives'

import './plugins'
import goodStorage from 'good-storage'

(function (d) {
  if (navigator.userAgent.indexOf('MSIE 9') === -1) return

  d.addEventListener('selectionchange', function () {
    var el = d.activeElement
    if (el.tagName === 'TEXTAREA' || (el.tagName === 'INPUT' && el.type === 'text') || (el.tagName === 'INPUT' && el.type === 'number') || (el.tagName === 'INPUT' && el.type === 'password')) {
      var ev = d.createEvent('CustomEvent')
      ev.initCustomEvent('input', true, true, {})
      el.dispatchEvent(ev)
    }
  })
})(document)
Es6Promise.polyfill()
if (Number.parseInt === undefined) Number.parseInt = window.parseInt
if (Number.parseFloat === undefined) Number.parseFloat = window.parseFloat

// import '@/styles/index.scss' // global css
const BigNumber = require('bignumber.js')
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

// 清除AMap的缓存，尝试解决部分AMap报错
setTimeout(() => {
  goodStorage.forEach(item => {
    if (item.includes('_AMap')) {
      goodStorage.remove(item)
    }
  })
  Vue.use(VueAMap)
})

for (const key in componentsList) {
  Vue.use(componentsList[key])
}
Vue.use(ElementUI)
Vue.use(YUI)

Vue.config.productionTip = false
Vue.prototype.BigNumber = BigNumber
Vue.prototype.$baseInfo = setting.baseInfo
Vue.prototype.$putIfAbsent = putIfAbsent

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
store.dispatch('getPageConfig')

window.addEventListener('load', function (e) {
  VueAMap.initAMapApiLoader({
    key: GDKye,
    plugin: ['AMap.Autocomplete', 'AMap.DistrictSearch', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor', 'AMap.Geocoder', 'Geolocation', 'CitySearch'],
    // 默认高德 sdk 版本为 1.4.4
    v: '1.4.4',
    events: {
      init (o) {
      }
    }
  })
})
